import { CopyOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMobile } from "../../../../../../context/MobileContext";
import { moneyFormat } from "../../../../../../plugins/numberFormat";
import { copyText, envChangeType, formatDate } from "../../../../../../plugins/utils";
import { useWallet } from "../../../../context/WalletContext";
import WalletRecord from "../../../WalletRecord";

const Record = ({ data, hasNextPage, fetchNextPage, isFetchingNextPage, setCurrentPage }) => {
  const { t } = useTranslation();
  const { isMobile } = useMobile();
  const { withdrawRecordItems, withdrawRecordActiveTab, setWithdrawRecordActiveTab } = useWallet();

  const columns = [
    {
      title: t("label.items"),
      key: "items",
      render: () => t("label.amount"),
      hide: isMobile,
    },
    {
      title: t("label.time"),
      dataIndex: "createtime",
      key: "createtime",
      render: (dom) => formatDate(dom),
    },
    {
      title: t("label.status"),
      dataIndex: "audit_status_text",
      key: "status",
    },
    {
      title: t("label.amount"),
      dataIndex: "money",
      key: "money",
      render: (dom) =>
        moneyFormat(dom) + " " + t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
    },
    {
      title: t("label.orderNumber"),
      key: "orderNumber",
      dataIndex: "sn",
      render: (dom) => {
        return (
          <div className="copyContainer" onClick={() => copyText(dom)}>
            {dom}
            <span className="copy">
              <CopyOutlined style={{ cursor: "pointer" }} />
            </span>
          </div>
        );
      },
      hide: isMobile,
    },
  ];

  useEffect(() => {
    if (!data) return;
    console.log(data);
  }, [data]);

  return (
    <WalletRecord
      data={data}
      items={withdrawRecordItems}
      activeTab={withdrawRecordActiveTab}
      setActiveTab={setWithdrawRecordActiveTab}
      columns={columns}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
      isFetchingNextPage={isFetchingNextPage}
      setCurrentPage={setCurrentPage}
      timeParam={"createtime"}
    />
  );
};

export default Record;
